import { type SVGProps } from 'react'

export const StickerPeelIcon: { __brand: 'color' | 'nocolor' } = (
  props: SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M31.7423 13.1207C30.3566 13.1197 25.6771 12.9436 21.3241 9.47722C16.901 5.95514 15.704 1.33662 15.4076 0.00112915C6.84553 0.312843 0 7.35431 0 15.9953C0 24.6362 7.16343 32.0002 16 32.0002C24.8366 32.0002 32 24.8346 32 15.9953C32 15.0139 31.9115 14.0532 31.7423 13.1207Z"
        fill="#FFBF47"
      />
      <path
        d="M15.4062 0C15.7017 1.3317 16.9069 5.95789 21.3303 9.48017C25.6511 13.0043 30.3244 13.1216 31.7466 13.1216L15.4062 0Z"
        fill="#E57300"
      />
      <path
        d="M16.5848 8.40568C16.4936 8.16171 16.2605 8 16 8C15.7395 8 15.5064 8.16171 15.4152 8.40568L13.7103 12.9652L8.84714 13.1777C8.58691 13.189 8.36108 13.3608 8.28059 13.6085C8.2001 13.8562 8.28186 14.1279 8.4857 14.29L12.2952 17.3204L10.9945 22.0112C10.9249 22.2622 11.0184 22.5301 11.2291 22.6832C11.4399 22.8363 11.7235 22.8425 11.9407 22.6987L16 20.0122L20.0593 22.6987C20.2765 22.8425 20.5601 22.8363 20.7709 22.6832C20.9816 22.5301 21.0751 22.2622 21.0055 22.0112L19.7048 17.3204L23.5143 14.29C23.7181 14.1279 23.7999 13.8562 23.7194 13.6085C23.6389 13.3608 23.4131 13.189 23.1529 13.1777L18.2897 12.9652L16.5848 8.40568Z"
        fill="#1C1C1C"
      />
    </svg>
  )
}

StickerPeelIcon.__brand = 'nocolor'
